import {noop} from '@benchling/js-utils';
import React, {useEffect} from 'react';

import {setWindowTitle} from 'BenchlingUtil';
import ChemicalCounterpartLibrary, {ChemicalCounterpartItem} from 'chemistry/ChemicalCounterpartLibrary';
import {TABLE_KEYS} from 'ui-library/scrollable/ScrollableTableConstants';

// Temporary mock data; once APIs are implemented this should come from GQL or similar. See MonomerListing for an example.
const STUB_SALTS: Array<ChemicalCounterpartItem> = [
  {
    id: 'slt_u4mPR8cA',
    name: 'Phosphate',
    counterpartType: 'Salt',
    code: 'PH',
    molecularFormula: 'H₂PO₄',
    molecularWeight: 47.9,
    canonicalSmiles: '[O-]P(=O)([O-])[O-]',
  },
  {
    id: 'slt_75yYmr8c',
    name: 'Potassium',
    counterpartType: 'Salt',
    code: 'K',
    molecularFormula: 'K',
    molecularWeight: 23.1,
    canonicalSmiles: '[K+]',
  },
  {
    id: 'slt_g4i6Kedc',
    name: 'Tartrate',
    counterpartType: 'Salt',
    code: 'TA',
    molecularFormula: 'C₄H₆O₆',
    molecularWeight: 87.4,
    canonicalSmiles: 'O=C(O)C(O)C(O)C(=O)O',
  },
  {
    id: 'slt_r2nXwQ7p',
    name: 'Sulfate',
    counterpartType: 'Salt',
    code: 'SU',
    molecularFormula: 'SO₄',
    molecularWeight: 70.2,
    canonicalSmiles: '[O-]S(=O)(=O)[O-]',
  },
];

export default function SaltLibrary(): JSX.Element {
  useEffect(() => {
    setWindowTitle('Salts');
  }, []);

  return (
    <ChemicalCounterpartLibrary
      title="Salt library"
      addNewLabel="Add new salt"
      items={STUB_SALTS}
      tableKey={TABLE_KEYS.SALT_LIBRARY_TABLE}
      searchPlaceholder="Salt name or code"
      onAddNew={noop}
    />
  );
}
